import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
export var newsBlock = /*#__PURE__*/css("margin-top:40px;", media('>=tablet'), "{margin:0 auto;margin-top:80px;}", media('>=desktop'), "{width:100%;}");
export var title = /*#__PURE__*/css(designTokenFonts.heading, ";color:", colour.neutral700, ";", media('>=desktop'), "{display:block;}");
export var titleBlock = /*#__PURE__*/css("display:flex;flex-direction:column;", media('>=desktop'), "{flex-direction:row;justify-content:space-between;}");
export var tabWrapper = /*#__PURE__*/css("display:flex;gap:45px;justify-content:center;margin-top:8px;", media('>=tablet'), "{justify-content:flex-start;margin-top:auto;}");
export var panelContent = /*#__PURE__*/css("width:auto;white-space:nowrap;overflow-x:auto;overflow-y:hidden;clear:left;", media('>=desktop'), "{overflow:hidden;}");
export var hidden = {
  name: "1hyfx7x",
  styles: "display:none;"
};
export var articlesList = {
  name: "1647809",
  styles: "margin-top:18px;"
};